import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { FictitiousMapModule } from '@blade-sxp/task-management/store/fictitiousMap';
let DrawListData = class DrawListData extends Vue {
    disabled;
    isRootNode;
    mapLoadStatus;
    virtualAreaImg = require('@blade-sxp/task-management/assets/virtual-area.png');
    get listPaintData() {
        return FictitiousMapModule.paintData;
    }
    get isData() {
        return FictitiousMapModule.paintData?.length > 0;
    }
    get getHotMapStatus() {
        return FictitiousMapModule.hotMapStatus;
    }
    startDraw() {
        const status = FictitiousMapModule.paintState;
        if (status) {
            FictitiousMapModule.updataPaintState(false);
        }
        else {
            FictitiousMapModule.updataPaintState(true);
        }
    }
    deleteRoi(id) {
        if (id) {
            FictitiousMapModule.clearPaintData();
        }
    }
};
__decorate([
    Prop({ default: false, type: Boolean })
], DrawListData.prototype, "disabled", void 0);
__decorate([
    Prop()
], DrawListData.prototype, "isRootNode", void 0);
__decorate([
    Prop()
], DrawListData.prototype, "mapLoadStatus", void 0);
DrawListData = __decorate([
    Component({
        name: 'DrawListData',
        components: {},
        i18n: {
            messages: {
                zh: {
                    examples: '示例',
                    noData: '请在左侧地图内圈定虚拟区域范围',
                    virtualArea: '虚拟区域',
                },
                en: {
                    examples: 'Example',
                    noData: 'please circle the virtual area on the map on the left',
                    virtualArea: 'Virtual Area',
                },
            },
        },
    })
], DrawListData);
export default DrawListData;
